import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import { useSetRecoilState } from 'recoil';

import { API_QUERY_KEYS } from 'api';
import { upsertParentOrganisation } from '../methods';
import {
  organisationRequestState,
  organisationIdState,
  organisationCreatedState,
} from 'store';
import { UpsertParentOrganisationRequest, UpsertParentOrganisationResponse } from '../types';
import { Organisation } from 'types';

export const useUpsertParentOrganisation = (): UseMutationResult<
  UpsertParentOrganisationResponse,
  unknown,
  UpsertParentOrganisationRequest
> => {
  const setUpdateSuccessRequest = useSetRecoilState(organisationRequestState);
  const setUpdatedOrganisationId = useSetRecoilState(organisationIdState);
  const setNewOrganisation = useSetRecoilState(organisationCreatedState);
  const queryClient = useQueryClient();
  return useMutation(upsertParentOrganisation, {
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getAllParentOrganisations] });
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getParentOrganisations] });
      setUpdateSuccessRequest(variables);
      setUpdatedOrganisationId(data.id);
      const newOrg: Organisation = {
        id: data.id,
        organisationName: variables.organisationName,
        email: variables.email,
      };
      setNewOrganisation(newOrg);
    },
  });
};
